module.exports = __webpack_public_path__ + "static/media/045-dentistry.d0b6e290.svg";